/**
 * Сетка карточек курсов и инструкций — одна на «Мои курсы», «Исследовать» и
 * «Мои инструкции». Колонки резиновые (`1fr`): карточка растягивается на свободную
 * ширину, а текст в ней растёт вместе с ней (`cqw` в самих карточках), поэтому
 * пропорции одинаковые от телефона до 1920. На телефоне — одна во всю ширину, на
 * планшете (`md`, меню там выезжает поверх) — ровно две, так решил Павел. С `lg`
 * минимум 240: в окне Windows с масштабом 125 % (≈830 px под сетку) влезают три. На
 * больших мониторах минимум крупнее — иначе шесть мелких карточек и пустота.
 */
export const CARD_GRID_CLASS =
  'grid gap-3 md:gap-5 [grid-template-columns:repeat(auto-fill,minmax(240px,1fr))] md:grid-cols-2 lg:[grid-template-columns:repeat(auto-fill,minmax(240px,1fr))] wide:[grid-template-columns:repeat(auto-fill,minmax(300px,1fr))]'

/** Боковые поля страниц со списками карточек — узкие: сетке отдаём ширину экрана. */
export const CARD_PAGE_PX_CLASS = 'px-4 md:px-6 lg:px-8 xl:px-10'
